/** Formats a calendar date for date-only API fields without a time or timezone. */
export function formatDateOnly(dateInput: Date | string): string {
  if (!dateInput) return '';

  if (dateInput instanceof Date) {
    const year = dateInput.getFullYear();
    const month = String(dateInput.getMonth() + 1).padStart(2, '0');
    const day = String(dateInput.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  return dateInput.split(/[T ]/, 1)[0];
}

/** Combines the selected calendar date with the current local time for Instant fields. */
export function formatDateWithCurrentTime(
  dateInput: Date | string,
  currentTime = new Date(),
): string {
  const date = formatDateOnly(dateInput);
  if (!date) return '';

  const [year, month, day] = date.split('-').map(Number);
  return new Date(
    year,
    month - 1,
    day,
    currentTime.getHours(),
    currentTime.getMinutes(),
    currentTime.getSeconds(),
    currentTime.getMilliseconds(),
  ).toISOString();
}
